import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { ApplicationBanner } from "../../blocks/application-banner";
import { ApplicationList } from "../../blocks/application-list";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { Notice } from "../../components/Notice";
import "./styles.less";

export const ApplicationPage = () => {
  const { t } = useTranslation();
  return (
    <div className="marketplace-intro-page">
      <Helmet>
        <title>
          通用登录组件-登录表单-社会化登录--Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="light" hasNotice />
      <ApplicationBanner
        name="applicationPage"
        title={t("application.banner.title")}
        subtitle={t("application.banner.subtitle")}
        img="//files.authing.co/authing-website/app-banner-img.png"
      />
      <ApplicationList />
      <HomeTryOn />
      <Footer />
    </div>
  );
};
